import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints,  } from '@angular/cdk/layout';
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BreakpointMonitorService {

  private _screenSmall$ = new BehaviorSubject<boolean>(false);
  public readonly screenSmall$ = this._screenSmall$.asObservable();
  
  public readonly breakpoint$ = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall]);

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpoint$.subscribe(() => {
      this.setScreenSize();
    });
   }


  setScreenSize() {
    if(this.breakpointObserver.isMatched(Breakpoints.Small) || this.breakpointObserver.isMatched(Breakpoints.XSmall)){
      this._screenSmall$.next(true);
    }else{
      this._screenSmall$.next(false);
    }
  }
}
